import { useEffect } from "react";
import type { PostProcessorModule } from "i18next";
import { getTranslationsPath } from "src/lib/i18next/getTranslationsPath.ts";
import { i18n } from "src/lib/i18next/i18next.ts";
import { useAppStore } from "src/hooks/useAppStore.ts";
import { appStore } from "src/stores/app.store.ts";

const wasShown = new Set();

const getPath = (
  ns: string | readonly string[] | null | undefined,
  lang: string | undefined,
) => {
  if (ns == null || !lang) {
    return "unknown";
  }
  if (Array.isArray(ns)) {
    return "unknown";
  }
  return getTranslationsPath(ns, lang) || "unknown";
};

const wrapOutputPlugin: PostProcessorModule = {
  type: "postProcessor",
  name: "wrapper",
  process(value, key, options) {
    const path = getPath(options.ns, options.lng);
    const unwrappedKey = Array.isArray(key) ? key.join(".") : key;
    const debugTranslations = appStore.debugTranslations;
    const uniqueKey = unwrappedKey + options.ns;
    if (!wasShown.has(uniqueKey) && debugTranslations) {
      wasShown.add(uniqueKey);

      const url = `https://link340.lcube-server.de/exonn-erp2/erp2-frontend/-/blob/staging/${path}`;
      /* eslint-disable no-console */
      console.debug(
        `Translation: ${value};`,
        `Url: ${url};`,
        `Key: ${unwrappedKey}`,
      );
    }

    return value;
  },
};

i18n.use(wrapOutputPlugin).init({
  postProcess: ["wrapper"],
});

export const useDebugTranslations = () => {
  const appStore = useAppStore();
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");

      // macOS uses metaKey (⌘), others use ctrlKey
      const isShortcutPressed =
        (isMac && event.metaKey) || (!isMac && event.ctrlKey);

      if (isShortcutPressed && event.key.toLowerCase() === "u") {
        event.preventDefault();
        const enabled = !appStore.debugTranslations;
        appStore.setDebugTranslations(enabled);
        /* eslint-disable no-console */
        console.log(
          enabled
            ? "Debug translations enabled"
            : "Debug translations disabled",
        );
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [appStore]);
};
